import { IKeyValueInterface, DataListModel } from "./../../shared/config";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ContractTypeModel } from "../models/contractType.model";
import { ContractTypeService } from "../models/contractType.service";
import { ContractTypeGroupService } from "../../contracttypegroup/models/contracttypegroup.service";
import { SharedVehicleGroupService } from "../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL
} from "../../shared/config";
import { DropdownModel } from "../../report/models/report-filter.model";
import { VatDefaultModel } from "../../vat-setting/models/vat-settings.model";

@Component({
  selector: "wego-contractType",
  template: require('../views/contractType-update.component.html'),
  providers: [
    ContractTypeService,
    SharedVehicleGroupService,
    ContractTypeGroupService
  ]
})
export class ContractTypeUpdateComponent implements OnInit, OnDestroy {
  contractTypeTypeList: any;
  private sub: any;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  public timeFormat: string = WeGoConfig.FLATPICKR_TIME_FORMAT;
  private popupMsg: string;
  private module: string;
  submitted = false;
  model: ContractTypeModel;
  apiResponse: IAPIResponse;
  svgList: any;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  message: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlContractTypeList: string;
  urlSVGList: string;
  urlContractTypeGroupList: string;
  contractTypeGroupHashId: string;
  sharedVehicleGroupHashId: string;
  specialPeriodList: any;
  contractTypePeriodList: any;
  DataListModel: DataListModel;
  isLoading: boolean;
  isContractPeriod: boolean;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  private contractTypeGroup: string;
  private sharedvehicleGroup: string;
  vatSettingList: DropdownModel[];
  vatSettingDefaultValues: VatDefaultModel;

  @ViewChild("alertModal") public alertModal: any;
  @ViewChild("successPopup") public successPopup: any;

  constructor(
    private contractTypeService: ContractTypeService,
    private svgService: SharedVehicleGroupService,
    private contracttypegroupService: ContractTypeGroupService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.contractTypeTypeList = [
      {
        Key: this.translate.instant("LblRegular"),
        Value: "REGULAR"
      },
      {
        Key: this.translate.instant("LblWeekEnd"),
        Value: "WEEKEND"
      },
      {
        Key: this.translate.instant("LblDayCT"),
        Value: "DAY"
      }
    ];
    this.module = this.translate.instant("LblContractType");
    this.sharedvehicleGroup = this.translate.instant("LblListPage", [
      this.translate.instant("LblSharedVehicleGroup")
    ]);
    this.contractTypeGroup = this.translate.instant("LblListPage", [
      this.translate.instant("LblContractTypeGroup")
    ]);

    this.DataListModel = new DataListModel();

    this.contractTypePeriodList = [
      {
        Key: "Select Contract Type Period",
        Value: ""
      },
      {
        Key: "NORMAL",
        Value: "NORMAL"
      },
      {
        Key: "SPECIAL",
        Value: "SPECIAL"
      }
    ];

    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlContractTypeList = this.authService.GetURL(
      ApplicationRouteURL.URL_CONTRACT_TYPE_LIST
    );
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.urlContractTypeGroupList = this.authService.GetURL(
      ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST
    );
    this.GetContractTypeDetails();
    this.GetSpecialPeriodsBySharedVehicleGroup();
  }

  onSubmit(forms: any) {
    console.log("ADD");
    this.submitted = true;
    console.log(this.model);
    this.AddNewContractType();
  }

  public GetContractTypeDetails() {
    this.model = new ContractTypeModel();
    this.model.contractTypeType = this.contractTypeTypeList[0].Value;
    this.isEditMode = false;
    this.sub = this.activeRoute.params.subscribe(params => {
      let contractTypeHashId = params["contractTypeHashId"] || "";
      this.sharedVehicleGroupHashId = params["sharedVehicleGroupHashId"] || "";
      this.contractTypeGroupHashId = params["contractTypeGroupHashId"] || "";
      this.model.contractTypeGroupHashId = this.contractTypeGroupHashId;
      this.GetVatSettingDropdownList();
      if (contractTypeHashId != "") {
        this.isEditMode = true;
        this.isContractPeriod = true;
        this.contractTypeService
          .GetContractTypeByHashId(contractTypeHashId)
          .subscribe(
            res => {
              this.model = res.data;
              this.model.contractTypeGroupHashId = this.contractTypeGroupHashId;
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
              this.isLoading = false;
            }
          );
      } else {
        this.GetCurrencyByGroup();
      }
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }
  public GetCurrencyByGroup() {
    this.contracttypegroupService
      .GetCurrencyByGroup(this.sharedVehicleGroupHashId)
      .subscribe(
        res => {
          if (res.data) {
            this.model.currencySymbol = res.data.currencySymbol;
            this.model.isCurrencySymbolBefore =
              res.data.currencySignBeforeAmount;
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public GetSpecialPeriodsBySharedVehicleGroup() {
    this.isLoading = true;
    this.contractTypeService
      .GetSpecialPeriods(this.sharedVehicleGroupHashId)
      .subscribe(
        res => {
          this.specialPeriodList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
          if (res.totalRecords == 0) {
            this.model.contractTypePeriod = this.contractTypePeriodList[1].Value;
            this.isContractPeriod = true;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }
  public AddNewContractType() {
    this.contractTypeService.AddContractType(this.model).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode
            ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
            : this.translate.instant("LblRecordAddedSuccess", [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public GetVatSettingDropdownList() {
    this.contracttypegroupService
      .GetVatSettingDropdownList(this.sharedVehicleGroupHashId)
      .subscribe(
        res => {
          if (res.data) {
            this.vatSettingList = res.data;
            if (!this.isEditMode) {
              this.GetVatSettingDefaultValues();
            }
          } else {
            //this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetVatSettingDefaultValues() {
    this.contracttypegroupService
      .GetVatSettingDefaultValues(this.sharedVehicleGroupHashId)
      .subscribe(
        res => {
          if (res.data) {
            this.vatSettingDefaultValues = res.data;
            this.model.hourlyRateVat = this.vatSettingDefaultValues.defaultVatTimeRates;
            this.model.mileageRateVat = this.vatSettingDefaultValues.defaultVatDistanceRates;
            this.model.vatSettingDefaultCost = this.vatSettingDefaultValues.vatSettingDefaultCost;
            this.model.fixedFeeVat = this.vatSettingDefaultValues.defaultVatFixedRates;
            this.model.periodRateVat = this.vatSettingDefaultValues.defaultVatPeriodRates;
            this.model.catAPricingModel.hourlyRateVat = this.vatSettingDefaultValues.defaultVatTimeRates;
            this.model.catAPricingModel.mileageRateVat = this.vatSettingDefaultValues.defaultVatDistanceRates;
            this.model.catAPricingModel.fixedFeeVat = this.vatSettingDefaultValues.defaultVatFixedRates;
            this.model.catAPricingModel.periodRateVat = this.vatSettingDefaultValues.defaultVatPeriodRates;
            this.model.catBPricingModel.hourlyRateVat = this.vatSettingDefaultValues.defaultVatTimeRates;
            this.model.catBPricingModel.mileageRateVat = this.vatSettingDefaultValues.defaultVatDistanceRates;
            this.model.catBPricingModel.fixedFeeVat = this.vatSettingDefaultValues.defaultVatFixedRates;
            this.model.catBPricingModel.periodRateVat = this.vatSettingDefaultValues.defaultVatPeriodRates;
            this.model.catCPricingModel.hourlyRateVat = this.vatSettingDefaultValues.defaultVatTimeRates;
            this.model.catCPricingModel.mileageRateVat = this.vatSettingDefaultValues.defaultVatDistanceRates;
            this.model.catCPricingModel.fixedFeeVat = this.vatSettingDefaultValues.defaultVatFixedRates;
            this.model.catCPricingModel.periodRateVat = this.vatSettingDefaultValues.defaultVatPeriodRates;
            this.model.catDPricingModel.hourlyRateVat = this.vatSettingDefaultValues.defaultVatTimeRates;
            this.model.catDPricingModel.mileageRateVat = this.vatSettingDefaultValues.defaultVatDistanceRates;
            this.model.catDPricingModel.fixedFeeVat = this.vatSettingDefaultValues.defaultVatFixedRates;
            this.model.catDPricingModel.periodRateVat = this.vatSettingDefaultValues.defaultVatPeriodRates;
            this.model.catEPricingModel.hourlyRateVat = this.vatSettingDefaultValues.defaultVatTimeRates;
            this.model.catEPricingModel.mileageRateVat = this.vatSettingDefaultValues.defaultVatDistanceRates;
            this.model.catEPricingModel.fixedFeeVat = this.vatSettingDefaultValues.defaultVatFixedRates;
            this.model.catEPricingModel.periodRateVat = this.vatSettingDefaultValues.defaultVatPeriodRates;
            this.model.catFPricingModel.hourlyRateVat = this.vatSettingDefaultValues.defaultVatTimeRates;
            this.model.catFPricingModel.mileageRateVat = this.vatSettingDefaultValues.defaultVatDistanceRates;
            this.model.catFPricingModel.fixedFeeVat = this.vatSettingDefaultValues.defaultVatFixedRates;
            this.model.catFPricingModel.periodRateVat = this.vatSettingDefaultValues.defaultVatPeriodRates;
            this.model.catGPricingModel.hourlyRateVat = this.vatSettingDefaultValues.defaultVatTimeRates;
            this.model.catGPricingModel.mileageRateVat = this.vatSettingDefaultValues.defaultVatDistanceRates;
            this.model.catGPricingModel.fixedFeeVat = this.vatSettingDefaultValues.defaultVatFixedRates;
            this.model.catGPricingModel.periodRateVat = this.vatSettingDefaultValues.defaultVatPeriodRates;
            this.model.catHPricingModel.hourlyRateVat = this.vatSettingDefaultValues.defaultVatTimeRates;
            this.model.catHPricingModel.mileageRateVat = this.vatSettingDefaultValues.defaultVatDistanceRates;
            this.model.catHPricingModel.fixedFeeVat = this.vatSettingDefaultValues.defaultVatFixedRates;
            this.model.catHPricingModel.periodRateVat = this.vatSettingDefaultValues.defaultVatPeriodRates;
          } else {
           // this.errorModel = res.error;
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public ShowAlertModal(): void {
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.alertModal.hide();
    this.router.navigate([this.urlContractTypeList]);
  }

  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
    this.router.navigate([
      this.urlContractTypeList,
      {
        sharedVehicleGroupHashId: this.sharedVehicleGroupHashId,
        contractTypeGroupHashId: this.contractTypeGroupHashId
      }
    ]);
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.router.navigate([
      this.urlContractTypeList,
      {
        sharedVehicleGroupHashId: this.sharedVehicleGroupHashId,
        contractTypeGroupHashId: this.contractTypeGroupHashId
      }
    ]);
  }

  public SetVatDefaultCost(vatSettingDefaultCost: boolean) {
    return vatSettingDefaultCost
      ? this.translate.instant("LblExcludingVat")
      : this.translate.instant("LblIncludingVat");
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/contractType/components/contractType-update.component.ts